/**
 * Shared OrangeBySite brand mark for customer-facing pages
 * (Phase 3H agreement review, project review, invoice pay pages …).
 *
 * Reuses the EXACT canonical logo asset the public homepage uses via
 * `/orangebysite-logo-white-black-v2.webp` — the same file the site Nav,
 * Footer, StandaloneHeader and HQBrand all pull from. NEVER redraws the
 * OrangeBySite wordmark and NEVER substitutes a font.
 *
 *   <OrangeBySiteLogo />                     desktop-first, ~h-12 md:h-16
 *   <OrangeBySiteLogo size="sm" />           email/footer compact use
 *   <OrangeBySiteLogo tone="dark" />         over the orange hero
 *
 * `tone` uses a colour-only CSS filter that leaves geometry untouched.
 */
import React from "react";

const LOGO_SRC = "/orangebysite-logo-white-black-v2.webp";

const SIZE = {
  sm: "h-8  w-auto",
  md: "h-12 md:h-[64px] w-auto",
  lg: "h-14 md:h-20 w-auto",
};

// Colour-only filters — NEVER alter proportion.
const TONE = {
  default: undefined,                     // untouched (renders as-is)
  black:   "brightness(0)",               // pure black over light bg
  white:   "brightness(0) invert(1)",     // pure white over orange/dark bg
};

export default function OrangeBySiteLogo({
  size = "md",
  tone = "default",
  className = "",
  linkToHome = true,
  testId = "obs-logo",
}) {
  const filter = TONE[tone];
  const img = (
    <img
      src={LOGO_SRC}
      alt="ORANGEBYSITE"
      className={`${SIZE[size] || SIZE.md} select-none object-contain block ${className}`}
      style={filter ? { filter, WebkitFilter: filter } : undefined}
      draggable={false}
    />
  );
  if (!linkToHome) {
    return <span className="inline-flex items-center leading-none" data-testid={testId}>{img}</span>;
  }
  return (
    <a
      href="/"
      className="inline-flex items-center leading-none"
      aria-label="OrangeBySite home"
      data-testid={testId}
    >
      {img}
    </a>
  );
}
